/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['mn', 'o', 'm', 'a', 'n'],
    ['middernag', 'die oggend', 'die middag', 'die aand', 'die nag'],
  ],
  [
    ['mn', 'o', 'm', 'a', 'n'],
    ['middernag', 'oggend', 'middag', 'aand', 'nag'],
  ],
  ['00:00', ['05:00', '12:00'], ['12:00', '18:00'], ['18:00', '24:00'], ['00:00', '05:00']]
];
